<ng-container [formGroup]="model">
  <lib-single-file-uploader
    [contextId]="'me'"
    [context]="avatarUploadContext"
    formControlName="file">

    <label>Twój avatar</label></lib-single-file-uploader>
  </ng-container>

  @if (model.value.file) {
    <lib-button (click)="crop()">Kadruj</lib-button>
    @if (model.value.cropped) {
      <img [src]="model.value.cropped | publicImageUrl:100:100:'zalamo' | async" />
    }
  }
